import { createSlice } from '@reduxjs/toolkit';

import { apiHostname } from 'shared/constants';
import { AlphamartHttpError } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

const notificationResolveSlice = createSlice<
  GenericStoreSlice,
  GenericStoreReducer<GenericStoreSlice>
>({
  name: 'notificationResolve',
  initialState: {
    isPending: false,
  },
  reducers: {
    ...getGenericReducers(),
  },
});

export const {
  pending: notificationResolveAction,
  success: notificationResolveSuccessAction,
  failure: notificationResolveFailureAction,
} = notificationResolveSlice.actions;

export const notificationResolve =
  (id: number): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      dispatch(notificationResolveAction());

      await httpClient.patch(`${apiHostname}/api/notifications/${id}/resolve`);

      return dispatch(notificationResolveSuccessAction({}));
    } catch (error) {
      dispatch(notificationResolveFailureAction());

      return Promise.reject((error as AlphamartHttpError)?.response?.data);
    }
  };

export default notificationResolveSlice.reducer;
